import { Article, BlogFaqItem, Category, Guide } from "../types";

const photo = (id: string) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=900&q=85`;

export const featuredArticles: Article[] = [
  {
    id: "career-you-love",
    title: "How to Build a Career You Love in 2024",
    excerpt: "Practical steps to find work that fits your strengths, goals and life.",
    category: "Career Advice",
    image: photo("photo-1551836022-d5d88e9218df"),
    author: "employHER team",
    date: "May 24, 2024",
  },
  {
    id: "interview-questions",
    title: "10 Common Interview Questions and How to Answer",
    excerpt: "Feel prepared with thoughtful answers that feel like you.",
    category: "Interview Tips",
    image: photo("photo-1573496359142-b8d87734a5a2"),
    author: "Priya Sharma",
    date: "May 22, 2024",
  },
  {
    id: "inclusive-workplace",
    title: "Building a More Inclusive Workplace for Everyone",
    excerpt: "Actionable ways employers can create a culture of belonging.",
    category: "Inclusive Hiring",
    image: photo("photo-1556761175-b413da4baf72"),
    author: "Rohit Verma",
    date: "May 18, 2024",
  },
  {
    id: "ai-careers",
    title: "How AI Is Changing the Way We Work",
    excerpt: "Explore the skills and habits that will help you stay future-ready.",
    category: "AI & Careers",
    image: photo("photo-1516321318423-f06f85e504b3"),
    author: "Meera Joshi",
    date: "May 14, 2024",
  },
];

export const latestArticles: Article[] = [
  {
    id: "job-search-strategies",
    title: "7 Job Search Strategies That Actually Work",
    excerpt: "",
    category: "Job Search",
    image: photo("photo-1484480974693-6ca0a78fb36b"),
    author: "Priya Sharma",
    date: "May 21, 2024",
  },
  {
    id: "ats-resume",
    title: "ATS-Friendly Resume: Tips and Examples",
    excerpt: "",
    category: "Resume & ATS",
    image: photo("photo-1586281380349-632531db7ed4"),
    author: "Neha Patel",
    date: "May 18, 2024",
  },
  {
    id: "career-break",
    title: "Returning to Work After a Career Break",
    excerpt: "",
    category: "Women at Work",
    image: photo("photo-1551836022-4c4c79ecde51"),
    author: "Ananya Iyer",
    date: "May 17, 2024",
  },
  {
    id: "ask-for-a-raise",
    title: "How to Ask for a Raise (with Confidence)",
    excerpt: "",
    category: "Career Advice",
    image: photo("photo-1556761175-5973dc0f32e7"),
    author: "Meera Joshi",
    date: "May 15, 2024",
  },
  {
    id: "hiring-trends",
    title: "Top Hiring Trends Employers Should Know",
    excerpt: "",
    category: "Hiring & Recruiting",
    image: photo("photo-1560250097-0b93528c311a"),
    author: "Rohit Verma",
    date: "May 9, 2024",
  },
];

export const categories: Category[] = [
  { label: "Career Advice", icon: "lightbulb" },
  { label: "Resume & ATS", icon: "description" },
  { label: "Interview Tips", icon: "forum" },
  { label: "Job Search", icon: "search" },
  { label: "AI & Careers", icon: "memory" },
  { label: "Women at Work", icon: "emoji_people" },
  { label: "Inclusive Hiring", icon: "groups" },
  { label: "Hiring & Recruiting", icon: "work" },
];

export const guides: Guide[] = [
  { title: "Resume Writing", description: "Build a resume that tells your story.", icon: "description", category: "Resume & ATS" },
  { title: "Interview Preparation", description: "Prepare thoughtful, confident answers.", icon: "forum", category: "Interview Tips" },
  { title: "Video Resumes", description: "Stand out with a powerful introduction.", icon: "videocam", category: "Career Advice" },
  { title: "Salary Negotiation", description: "Know your value and ask with confidence.", icon: "trending_up", category: "Career Advice" },
  { title: "Job Search", description: "Find the right next role for you.", icon: "search", category: "Job Search" },
];

export const faqs: BlogFaqItem[] = [
  {
    question: "How can I find the right job for my skills and experience?",
    answer: "Start by identifying the skills, work environment and growth opportunities that matter most to you. Use those priorities to narrow your search and tailor each application.",
  },
  {
    question: "How do I write an ATS-friendly resume?",
    answer: "Use clear headings, a simple layout and the relevant keywords from the job description. Focus on measurable results, not only responsibilities.",
  },
  {
    question: "What are the most common interview questions?",
    answer: "Prepare concise examples for questions about your experience, strengths, challenges, teamwork and interest in the role. The STAR method can keep your answers focused.",
  },
  {
    question: "How can I negotiate my salary confidently?",
    answer: "Research the market range, decide on your target and practice a clear value statement. Treat the conversation as a collaborative discussion about the role and your impact.",
  },
  {
    question: "How can employers build a more inclusive workplace?",
    answer: "Make hiring, progression and feedback practices consistent and transparent. Listen to employees regularly, measure outcomes and give managers the support to act on what they learn.",
  },
  {
    question: "How can employers hire the right talent?",
    answer: "Define the outcomes of the role, use structured interviews and assess candidates against the same criteria. A clear, respectful process improves both hiring quality and candidate experience.",
  },
];
